import Task from "../../../../model2/task/task"
import {ProjectAccess} from "../../../../gd/const/project"
import UserToAdd from "../add-user"
import {getAllProjectIds, getUsersOnAllTasks} from "./helpers"


// Users that already belong to EVERY project the selected tasks live in
// (main + linked) and are missing from at least one of those tasks. Picking
// such a user only requires a task_user insert - they already have project
// (and therefore workspace) access.
export function bulkComputeProjectUsers(tasks: Task[], taskUserIdsByTaskId: Map<ID, ID[]>): UserToAdd[] {
    const allProjectIds = getAllProjectIds(tasks)
    const onAllTasks    = getUsersOnAllTasks(tasks, taskUserIdsByTaskId)

    const candidateUserIds : Set<ID> = new Set()
    _.each(allProjectIds, (projectId: ID) => {
        const project = gd.session.projects.get(projectId)
        if (!project) return
        _.each(project.userIds(ProjectAccess.LIMITED), (userId: ID) => candidateUserIds.add(userId))
    })

    const models : UserToAdd[] = []

    candidateUserIds.forEach((userId: ID) => {
        if (onAllTasks.has(userId)) return

        const inAllProjects = _.every(allProjectIds, (projectId: ID) => {
            const project = gd.session.projects.get(projectId)
            return !!project && project.userIds(ProjectAccess.LIMITED).includes(userId)
        })
        if (!inAllProjects) return

        const companyUser = gd.session.companyUsers.getByUserId(userId)
        if (companyUser) models.push(new UserToAdd(companyUser))
    })

    return models
}
